import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { needToKnow, stats } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function SystemIntro() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-244" data-mp="thrb3p06c8er">
      <div className="mx-auto max-w-4xl" data-id="element-245" data-mp="tij916h8ui87">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-246" data-mp="ohlrmw425s7r">
          From a case that feels overwhelming…
          <span className="mt-2 block italic text-teal" data-id="element-247" data-mp="12ftiqneexzb0">to a case I can review with a system.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-relaxed text-ink-muted" data-id="element-248" data-mp="yei0x41s6idd">
          When I look at a complex rhinoplasty case, I don’t need another 15-hour course sitting in my library. I need to know:
        </p>

        <ul className="mx-auto mt-8 grid max-w-2xl gap-3" data-id="element-249" data-mp="1m54005tt4sb8">
          {needToKnow.map(q => <li key={q} className="flex items-center gap-3 rounded-2xl bg-teal-soft px-4 py-4 text-[17px] font-semibold text-navy" data-id="element-250" data-mp="1h7lnk5gkzuyh">
              <HelpCircleIcon className="h-6 w-6 shrink-0 text-teal" aria-hidden="true" data-id="element-251" data-mp="1vmx0mq7b69ws" />
              {q}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg font-semibold text-navy" data-id="element-252" data-mp="24maahjzch0i1">
          That’s exactly why the Rhinoplasty Master Planner™ was created.
        </p>

        <div className="mt-14 rounded-3xl bg-navy px-5 py-10 text-center sm:px-10" data-id="element-253" data-mp="29ir0kjq3toxr">
          <h3 className="font-serif text-2xl font-extrabold leading-snug text-white sm:text-4xl" data-id="element-254" data-mp="2ei3x5w6s2adj">
            It helps me complete a structured case review in <span className="italic text-teal-light" data-id="element-255" data-mp="2o9rhze8twt61">10 minutes</span>
          </h3>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-256" data-mp="2sbd1hifvc5p7">
            Instead of scattered notes, disconnected checklists and information stored across different documents… I have one structured planning system that guides me through the entire case-review process.
          </p>
          <dl className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-257" data-mp="126rkaf6zb0ls">
            {stats.map(s => <div key={s.label} className="rounded-2xl bg-navy-700 px-3 py-5" data-id="element-258" data-mp="x9hnufl69oog">
                <dt className="sr-only" data-id="element-259" data-mp="1bxuqfverm5rx">{s.label}</dt>
                <dd className="font-serif text-3xl font-extrabold text-teal-light sm:text-4xl" data-id="element-260" data-mp="1bzfinedlxcmm">{s.value}</dd>
                <dd className="mt-1 text-[13px] font-medium leading-snug text-white/80" data-id="element-261" data-mp="174t5b5nyt9zw">{s.label}</dd>
              </div>)}
          </dl>
        </div>

        <CtaButton label="I want to plan my cases with a system" className="mt-10" data-id="element-262" data-mp="1gvntwgoooloi" />
      </div>
    </section>;
}